function DashboardInicio() {
  
    return (
      <div>Selecciona una opcion</div>
    )
  }
  
  export default DashboardInicio;